import { Button, Divider } from "@mui/material";
import { SideNav } from "components";
import { Icons, LargeButton, MainBody, PageTitle, Ptag } from "components/core";
import React, { useMemo, useState } from "react";
import { DownloadTemplateWrapper, UploadDocumentButton } from "../styles";
import { colors } from "theme";
import config from "../../../config.json";
import axios from "axios";
import { ALL_PRODUCTS } from "constants";
import http from "services/httpService";
import { useNavigate, useLocation } from "react-router";
import routes from "components/routes";
import { OverlayLoader } from "components/core";
import DownloadIcon from "assets/svgs/downloadGrey.svg";

const BulkProductUpload = () => {
  const { state } = useLocation();
  const flexUserplanIds = JSON.parse(localStorage.getItem("flex_userplan_ids"));

  const navigate = useNavigate();
  const products = JSON.parse(localStorage.getItem("flex_userplan_ids"));
  const getInitialProds = () => {
    return Object.keys(products).reduce((acc, product) => {
      acc[product] = {};
      return acc;
    }, {});
  };
  const [isLoading, setIsLoading] = useState(false);
  const [uploadedDocuments, setUploadedDocuments] = useState(getInitialProds());
  const handleFileChange = (product, event) => {
    uploadFile(event.target.files[0], product);
  };

  const uploadFile = async (file, product) => {
    const supportedFormats = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ];
    if (!file) {
      return;
    } else if (!supportedFormats.includes(file.type)) {
      alert("Please upload file in correct format");
      return;
    }
    let formData = new FormData();
    formData.append("file_details", file);

    try {
      formData.append("file_owner", localStorage.getItem("id"));
      formData.append("file_type", "employees_excel");
      const { data } = await axios({
        url: config.apiUrl + "/insurance/upload_document/",
        method: "POST",
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      setUploadedDocuments((prev) => ({
        ...prev,
        [product]: {
          ...prev[product],
          document: data,
          file,
        },
      }));
    } catch (ex) {
      // setLoading(false)
    }
  };

  const productName = (productKey) => {
    return ALL_PRODUCTS[productKey];
  };

  const getFileName = (product) => {
    if (product && product.file) {
      return product.file.name;
    }
  };

  const isDisabled = useMemo(() => {
    const flow = sessionStorage.getItem("flex_setup_type");
    if (flow === "add_delete") {
      const isAnyProductUploaded = Object.values(uploadedDocuments).some(
        (product) => product.document
      );
      return !isAnyProductUploaded;
    }
    return Object.values(uploadedDocuments).some(
      (product) => !product.document
    );
  }, [uploadedDocuments]);

  const getEmployeeSheetMapping = () => {
    console.log({uploadedDocuments})
    return Object.keys(uploadedDocuments).reduce((acc, product) => {
      if(uploadedDocuments[product].document) {
        acc[flexUserplanIds[product]] = uploadedDocuments[product].document.id;
      }
      return acc;
    }, {});
  };

  const uploadEmployeeSheets = async () => {
    const flow = sessionStorage.getItem("flex_setup_type");
    const super_task_id = localStorage.getItem("super_task_id");
    const payload = {
      upload_flow: flow ? flow : "setup",
      product_employee_sheet_mapping: getEmployeeSheetMapping(),
      super_task_id,
      page: "product_employee",
    };
    try {
      setIsLoading(true);
      const { data } = await http.post(
        "business/employee_data_upload_pre_issuance/",
        payload
      );
      setTimeout(() => {
        setIsLoading(false);
        navigate(
          {
            pathname: `/${routes.FLEX_PRODUCT_STATUS}`,
            state: { flow: state && state.flow },
          },
          {
            replace: true,
          }
        );
      }, 3000);
    } catch (ex) {
      alert("Something went wrong");
    }
  };

  const downloadTemplate = async (product) => {
    const userplanId = flexUserplanIds[product];
    await downloadExcel(userplanId);
  };

  const downloadExcel = async (userplanId) => {
    const payload = {
      plan_id: userplanId,
    };
    const { data } = await http.post(
      "business/product_employee_sheet_skeleton/",
      payload,
      { responseType: "blob" }
    );
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(new Blob([data]));
    link.download = "employee_sheet.xlsx";

    // Append link to the DOM and click it
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  };

  return (
    <>
      {isLoading ? (
        <OverlayLoader />
      ) : (
        <>
          <SideNav />
          <MainBody
            style={{
              maxWidth: "800px",
              minHeight: "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div>
              <PageTitle title="Upload Employee Data" />
              <div style={{ marginTop: "5rem" }}>
                {Object.keys(products).map((product) => (
                  <div
                    style={{
                      marginBottom: "5rem",
                    }}
                    key={product}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "space-between",
                      }}
                    >
                      <Ptag fontSize="18px" fontWeight="600">
                        {productName(product)}
                      </Ptag>
                      <DownloadTemplateWrapper
                        onClick={() => downloadTemplate(product)}
                      >
                        <img src={DownloadIcon} width={18} />
                        <Ptag
                          fontSize="14px"
                          marginLeft="4px"
                          color={colors.primaryColor}
                          style={{ textDecoration: "underline" }}
                        >
                          Download Format
                        </Ptag>
                      </DownloadTemplateWrapper>
                    </div>
                    <Divider
                      sx={{
                        margin: "18px 0",
                      }}
                    />
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Button
                        sx={{
                          backgroundColor: colors.accentColor,
                          boxShadow: "none",
                          textTransform: "initial",
                          fontSize: "14px",
                          padding: "1rem 2.4rem",
                          fontFamily: "Inter",
                          borderRadius: "10px",
                        }}
                        variant="contained"
                        startIcon={<Icons icon="upload" />}
                        component="label"
                      >
                        Upload Excel
                        <input
                          type="file"
                          hidden
                          onChange={(e) => handleFileChange(product, e)}
                          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        />
                      </Button>
                      <Ptag fontSize="14px" marginLeft="20px">
                        {getFileName(uploadedDocuments[product])}
                      </Ptag>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <LargeButton
              label="Save & Next"
              disabled={isDisabled}
              onClick={uploadEmployeeSheets}
              style={{
                opacity: isDisabled ? 0.5 : 1,
              }}
            />
          </MainBody>
        </>
      )}
    </>
  );
};

export default BulkProductUpload;
